export interface ThemeQuestionFormValue {
  questionText: string;
  language: string;
  domain: string;
  source: string;
}

export const EMPTY_THEME_QUESTION: ThemeQuestionFormValue = {
  questionText: '',
  language: '',
  domain: '',
  source: '',
};
